import sanitizeHtmlPackage from 'sanitize-html';

// can be used when we want to apply multiple functions
// to parse the html
// ie:
// chain(body,
//   [stripParagraphsWithNbsp, sanitizeHtml])
export const chain = (value: any, functions: Array<any>) =>
  functions.reduce((r, f) => f(r), value);

export const sanitizeConfigs = {
  defaultWithImageAndHeadings: {
    allowedTags: sanitizeHtmlPackage.defaults.allowedTags.concat([
      'img',
      'h1',
      'h2',
    ]),
    allowedAttributes: {
      ...sanitizeHtmlPackage.defaults.allowedAttributes,
      img: sanitizeHtmlPackage.defaults.allowedAttributes.img.concat(['alt']),
      a: sanitizeHtmlPackage.defaults.allowedAttributes.a.concat(['rel']),
      ol: ['start'],
    },
    allowedClasses: {
      div: ['table-wrapper'],
    },
  },
} as const;

// wrapper function to pass default configuration;
export const sanitizeHtml = (
  html: string,
  config: any = sanitizeConfigs.defaultWithImageAndHeadings,
) => sanitizeHtmlPackage(html, config);

export const stripParagraphsWithNbsp = (htmlAsString: string) =>
  htmlAsString.split('<p>&nbsp;</p>').join('');

export const unescapeString = (encodedStr: string): string => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(sanitizeHtml(encodedStr), 'text/html');
  const decodedString = dom?.body?.textContent;
  return decodedString || '';
};
